<template>
    <div class="menuBar" v-bind:class="{visible: notHomePage}">
        <img class="logo" src="@/assets/images/saab-logo-white.svg" alt="" v-on:click="$root.toggleFullscreen()">
        <div class="navigationMenu">
            <div class="naviationMenu__items">
                <router-link to="/">Home</router-link>
                <router-link to="/scenarios">Scenarios</router-link>
                <router-link to="/cbrn-products">CBRN Products</router-link>
                <router-link to="/key-benefits">Key Benefits</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'NavigationMenu',
  computed: {
      notHomePage: function() {
          return this.$route.path !== '/'
      }
  }
}
</script>

<style lang="scss" scoped>
    .menuBar {
        display: flex;
        background-color: $colour__primary1;
        padding: 1rem;
        transition: all 0.5s;
        transform: translate3d(0, -100%, 0);
        position: relative;
        z-index: 100;
        // height: 6rem;
        padding: 1rem 1.4rem;
        &.visible {
            transform: translate3d(0,0,0);
        }
    }

    .navigationMenu {
        float: right;
        flex-grow: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        a {
            padding: 0 1rem;
            border-left: 1px solid $white;

            &:first-of-type {
                border-left: 0;
            }

            &:last-of-type {
                padding-right: 0;
            }
        }
    }

    .logo {
        display: block;
        height: 3.4rem;
        flex-grow: 0;
    }

    a {
        color: $white;
        text-transform: uppercase;
        &:hover {
            color: $colour__accent1;
        }
        &.router-link-exact-active {
            color: $colour__accent1;
        }
    }
</style>
